/**
 * Дефолты для обязательных полей PocketBase.
 * Частичный update падает с «Поле обязательно», если в БД значение null (legacy / миграции).
 */

export function normalizeBool(value: unknown, fallback = false): boolean {
  return typeof value === 'boolean' ? value : fallback
}

export function normalizeNumber(value: unknown, fallback = 0): number {
  const n = Number(value)
  return Number.isFinite(n) ? n : fallback
}

export function buildTimesheetEntryCreate(input: {
  worker: string
  workDate: string
  shift?: string
  machine?: string
  scheduleSlot?: string
  present?: boolean
  hours?: number
  recordedBy?: string
  notes?: string
}): Record<string, unknown> {
  const workDate = input.workDate.includes('T') || input.workDate.includes(' ')
    ? input.workDate
    : `${input.workDate} 12:00:00`
  return {
    worker: input.worker,
    workDate,
    shift: input.shift || '',
    machine: input.machine || '',
    scheduleSlot: input.scheduleSlot || '',
    present: input.present ?? true,
    hours: input.hours ?? 0,
    recordedBy: input.recordedBy || '',
    notes: input.notes ?? '',
  }
}

/** Patch табеля: всегда сохраняем present (required bool). */
export function timesheetEntryUpdatePatch(
  entry: { present?: boolean | null },
  patch: Record<string, unknown>,
): Record<string, unknown> {
  return {
    present: normalizeBool(entry.present, false),
    ...patch,
  }
}

/** Patch расходника: price и stockQty обязательны. */
export function consumableSavePatch(
  existing: { price?: number | null; stockQty?: number | null } | null | undefined,
  patch: Record<string, unknown>,
): Record<string, unknown> {
  return {
    price: normalizeNumber(existing?.price, 0),
    stockQty: normalizeNumber(existing?.stockQty, 0),
    ...patch,
  }
}

/** Patch строки заявки: всегда status, priority, shippedQty (0 допустим после миграции 1745190032). */
export function productionRequestLineUpdatePatch(
  existing: {
    status?: string | null
    priority?: number | null
    shippedQty?: number | null
  },
  patch: Record<string, unknown>,
): Record<string, unknown> {
  const { shippedQty: patchShipped, ...restPatch } = patch
  return {
    status: existing.status || 'pending',
    priority: normalizeNumber(existing.priority, 3),
    shippedQty: normalizeNumber(
      patchShipped !== undefined ? patchShipped : existing.shippedQty,
      0,
    ),
    ...restPatch,
  }
}
